import { IThemeProviderProps } from "@framework/provider-theme";
import { grey, lightBlue } from "@mui/material/colors";

import Raleway300 from "../assets/fonts/Raleway-Light.ttf";
import Raleway400 from "../assets/fonts/Raleway-Regular.ttf";
import Raleway500 from "../assets/fonts/Raleway-Medium.ttf";
import Raleway600 from "../assets/fonts/Raleway-SemiBold.ttf";
import Raleway700 from "../assets/fonts/Raleway-Bold.ttf";
import Raleway800 from "../assets/fonts/Raleway-ExtraBold.ttf";
import Roboto300 from "../assets/fonts/Roboto-Light.ttf";
import Roboto400 from "../assets/fonts/Roboto-Regular.ttf";
import Roboto500 from "../assets/fonts/Roboto-Medium.ttf";

export const themeProps: IThemeProviderProps = {
  darkPalette: {
    primary: lightBlue,
    secondary: grey,
  },
  lightPalette: {
    primary: lightBlue,
    secondary: grey,
  },
  options: {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1440,
        xl: 1920,
        xxl: 2048,
      },
    },
    typography: {
      fontFamily: [
        "Raleway",
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      fontWeightRegular: 500,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
          @font-face {
            font-family: 'Raleway';
            font-style: normal;
            font-display: swap;
            font-weight: 300;
            src: local('Raleway'), local('Raleway-Light'), url(${Raleway300}) format('ttf');
          }
          @font-face {
            font-family: 'Raleway';
            font-style: normal;
            font-display: swap;
            font-weight: 400;
            src: local('Raleway'), local('Raleway-Regular'), url(${Raleway400}) format('ttf');
          }
          @font-face {
            font-family: 'Raleway';
            font-style: normal;
            font-display: swap;
            font-weight: 500;
            src: local('Raleway'), local('Raleway-Medium'), url(${Raleway500}) format('ttf');
          }
          @font-face {
            font-family: 'Raleway';
            font-style: normal;
            font-display: swap;
            font-weight: 600;
            src: local('Raleway'), local('Raleway-SemiBold'), url(${Raleway600}) format('ttf');
          }
          @font-face {
            font-family: 'Raleway';
            font-style: normal;
            font-display: swap;
            font-weight: 700;
            src: local('Raleway'), local('Raleway-Bold'), url(${Raleway700}) format('ttf');
          }
          @font-face {
            font-family: 'Raleway';
            font-style: normal;
            font-display: swap;
            font-weight: 800;
            src: local('Raleway'), local('Raleway-ExtraBold'), url(${Raleway800}) format('ttf');
          }
          @font-face {
            font-family: 'Roboto';
            font-style: normal;
            font-display: swap;
            font-weight: 300;
            src: local('Roboto'), local('Roboto-Light'), url(${Roboto300}) format('ttf');
          }
          @font-face {
            font-family: 'Roboto';
            font-style: normal;
            font-display: swap;
            font-weight: 400;
            src: local('Roboto'), local('Roboto-Regular'), url(${Roboto400}) format('ttf');
          }
          @font-face {
            font-family: 'Roboto';l
            font-style: normal;
            font-display: swap;
            font-weight: 500;
            src: local('Roboto'), local('Roboto-Medium'), url(${Roboto500}) format('ttf');
          }
          body {
            background-color: #FAFAFF;
            font-family: Raleway;
            font-feature-settings: 'pnum' on, 'lnum' on;
          }
        `,
      },
    },
  },
};
